import { homepageBreadcrumbs, PageContextProvider } from './index'
import { Context } from '../server-middleware/context'

const page: PageContextProvider = (context: Context) => {
  return {
    widgets: [{
      id: 0,
      type: 'group_overview',
      title: null,
      active: true
    }],

    name: 'group-overview',
    url: '/group/overviewJS',
    breadcrumbs: [
      homepageBreadcrumbs(context.modules),
      {
        phrase: ['Forum', 'groups'],
        url: './'
      }
    ]
  }
}

export default page
